<template>
  <div class="tabs_content">
    <section v-if="entities">
      <div class="filter search_only">
        <div class="field_left">
          <search-input input-class="search" v-model="formFields.search" />
        </div>
        <div class="field_right" v-if="this.subscriberSummed.pvr_free_minutes">
          <div class="remaining-space">
            <div class="progressbar">
              <div class="progressbar__actual" :style="{ 'width': this.usedMinutesPercentage + '%' }">
                <div class="progressbar__show" :style="{ 'width': (100 - this.usedFilteredMinutesPercentage) + '%' }" />
              </div>
            </div>
            <div class="actual-space">{{ usedTimeFormattedString }}</div>
          </div>
        </div>
      </div>

      <div class="scroll-wrapper">
      <div class="table_overflow" id="contentBox" data-table-id="subscribers-pvrs">
          <table class="vypis">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in tableTitles"
                  :key="title.id"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding edit"></th>
            </tr>
            </thead>
            <tbody>
            <PvrRow v-for="pvr in entities"
                    :pvr="pvr"
                    :key="pvr.id"
                    ref="pvr_row"
                    :selectedEntities="selectedEntities"
                    :isDeletable="isEditable"
                    @input="select"
                    @deletePvr="onDeletePvr" />
            <tr v-if="entities.length === 0">
              <td colspan="9" v-translate>Nebyly nalezeny žádné nahrávky.</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="subscribers-pvrs"
          @select-all="toggleSelectAll"
          @run-multiple-action="_executeMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      />
    </section>
  </div>
</template>

<script>
import PvrRow from "./PvrRow";
import listActions from "../../../mixins/list-actions";

export default {
  name: "SubscriberDetailPvrs",
  components: { PvrRow },
  mixins: [ listActions ],
  props: {
    entity: Object,
    isEditable: Boolean,
  },
  data() {
    return {
      entities: [],
      totalCount: 0,
      usedMinutes: 0,
      usedFilteredMinutes: 0,
      subscriberSummed: {},
      serviceIntervalsOptions: [],
    }
  },
  created(SubscriberService, PvrService) {
    this.subscriberService = SubscriberService
    this.pvrService = PvrService

    this.getEntities()
    this.getSubscriberFinalServiceByInterval()
  },
  methods: {
    getEntities() {
      const params = { ...this.getFormFields() }
      this.subscriberService.getSubscriberPvrs(this.entity.id, params).then((data) => {
        this.entities = data['pvrs']
        this.totalCount = data['totalCount']
        this.usedMinutes = data['usedMinutes']
        this.usedFilteredMinutes = data['usedFilteredMinutes']
      })
    },
    onDeletePvr(id, showPopup = true) {
      if (showPopup) {
        this.showPopup(id, 'delete', 'deletePvr');
      } else {
        this.pvrService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
            .then(() => {
              this.setSuccessMessage()
              this.getEntities()
            })
            .catch(function (error) {
              this.getEntities()
              this.setErrorMessage(this._processDetailErrorMessage(error))
            }.bind(this))
      }
    },
    _executeMultipleAction(action, activeKey) {
      let actionIds = this.selectedEntities.join();
      switch (action) {
        case 'delete-multi':
          this.onDeletePvr(actionIds);
          break;
        default:
          this.executeMultipleAction(action, activeKey);
      }
    },
    _exportCsv() {
      this.setLoadingMessage()
      const params = { ...this.getFormFields() }
      delete params.limit;
      delete params.offset;
      this.subscriberService.getSubscriberPvrs(this.entity.id, params).then((data) => {
        this._createExportCsv(this.csvHeaders, data['pvrs']);
      })
    },

    getSubscriberFinalServiceByInterval(interval = null) {
      let params = null
      if (interval !== null) {
        let splitValues = this._.split(interval, '-')
        // always send "from" except when "from" is null/zero/unlimited, in such case send "to"
        let timestamp = Number(splitValues[0]) === 0 ? Number(splitValues[1]) : Number(splitValues[0])
        params = {'timestamp': timestamp}
      }

      this.setLoadingMessage()
      this.subscriberService.getSubscriberServiceIntervals(this.entity.id, params)
          .then(data => {
            this.emptyMessage()
            this.subscriberSummed = data['summed']
            this.serviceIntervalsOptions = data['service_intervals_options'].map(item => {
              let newText = item.text;

              if (newText.includes("neomezeně")) {
                newText = newText.replace(/neomezeně/g, this.$gettext("neomezeně"));
              }

              return {
                ...item,
                text: newText
              };
            });
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    },
  },
  computed: {
    tableTitles() {
      return [
        { id: 1, name: this.$gettext('Název'), column: 'sName' },
        { id: 2, name: this.$gettext('Stav'), column: 'sDateExpired' },
        { id: 3, name: this.$gettext('Kanál') },
        { id: 4, name: this.$gettext('Nahráno na') },
        { id: 5, name: this.$gettext('Uživatelské profily') },
        { id: 6, name: this.$gettext('Délka') },
        { id: 7, name: this.$gettext('Datum vysílání'), column: 'sBroadcastStart' },
        { id: 8, name: this.$gettext('Datum nahrání'), column: 'sDateCreated' },
        { id: 9, name: this.$gettext('Datum expirace'), column: 'sDateExpired' },
      ]
    },
    multipleActionOptions() {
      return [
        { value: 'choose', text: this.$gettext('Vyberte akci') },
        { value: 'exportCsv', text: this.$gettext('Exportovat do CSV') },
        { value: 'delete-multi', text: this.$gettext('Smazat') }
      ];
    },
    csvHeaders() {
      return {
        'name': { name: this.$gettext('Název') },
        'state': {
          name: this.$gettext('Stav'), callback: (entity, index) => {
            return this.$refs.pvr_row[index].stateString()
          }
        },
        'name_channel': {
          name: this.$gettext('Kanál'), callback: (entity) => {
            return entity.channel_hd ? entity.name_channel + ' HD' : entity.name_channel;
          }
        },
        'name_device': { name: this.$gettext('Nahráno na') },
        'profiles': {
          name: this.$gettext('Uživatelské profily'), callback: (entity) => {
            return entity.profiles.map(i => i.name).join(', ')
          }
        },
        'length': {
          name: this.$gettext('Délka'), callback: (entity) => {
            return this.$_formatMinutesToString(entity.length / 60)
          }
        },
        'timestamp_broadcast_start': {
          name: this.$gettext('Datum vysílání'), callback: (entity) => {
            return entity.timestamp_broadcast_start ? this.$_datetime_format(entity.timestamp_broadcast_start) : ''
          }
        },
        'timestamp_created': {
          name: this.$gettext('Datum vysílání'), callback: (entity) => {
            return entity.timestamp_created ? this.$_datetime_format(entity.timestamp_created) : ''
          }
        },
        'timestamp_expiration': {
          name: this.$gettext('Datum vysílání'), callback: (entity) => {
            return entity.timestamp_expiration ? this.$_datetime_format(entity.timestamp_expiration) : ''
          }
        },
      }
    },
    usedMinutesPercentage() {
      return ~~((this.usedMinutes / this.freeMinutes) * 100);
    },
    usedFilteredMinutesPercentage() {
      return ~~((this.usedFilteredMinutes / this.usedMinutes) * 100);
    },
    freeMinutes() {
      return this.subscriberSummed.pvr_free_minutes || 0;
    },
    formattedFreeHours() {
      return this.$_formatMinutesToString(this.freeMinutes);
    },
    formattedUsedHours() {
      return this.$_formatMinutesToString(this.usedMinutes);
    },
    usedTimeFormattedString() {
      if (this.usedMinutes > 0) {
        return this.$gettextInterpolate(this.$gettext("Využito %{used} z %{total}"), {
          used: this.formattedUsedHours,
          total: this.formattedFreeHours
        });
      } else {
        return this.$gettextInterpolate(this.$gettext("K dispozici %{total}"), {
          total: this.formattedFreeHours
        });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/pvrs/Pvrs.vue